import { yieldToMain } from 'assets/core/js/common'

export interface Config {
  onClickSearchButton?: () => void
  onClickFilterButton?: () => void
  onClickMapButton?: () => void
}

export default (el: HTMLElement, config: Config): void => {
  const searchButton = el.querySelector<HTMLElement>('button[data-target="search"]')
  const filterButton = el.querySelector<HTMLElement>('button[data-target="filter"]')
  const mapButton = el.querySelector<HTMLElement>('button[data-target="map"]')

  if (!config) {
    return
  }

  if (searchButton) {
    searchButton.addEventListener('click', () => {
      void (async () => {
        await yieldToMain()
        config.onClickSearchButton && config.onClickSearchButton()
      })()
    })
  }

  if (filterButton) {
    filterButton.addEventListener('click', () => {
      void (async () => {
        await yieldToMain()
        config.onClickFilterButton && config.onClickFilterButton()
      })()
    })
  }

  if (mapButton) {
    mapButton.addEventListener('click', () => {
      void (async () => {
        await yieldToMain()
        config.onClickMapButton && config.onClickMapButton()
      })()
    })
  }
}
